import React from "react";

import { Body, PageTitle } from "src/components/typography/typography";

/*
 * Types
 */

export interface ErrorProps {
    readonly message?: string;
    readonly title?: string;
}

/*
 * Main
 */

export const Error = (props: ErrorProps): React.ReactElement => {
    const {
        message = "Well this is embarrassing...something went wrong on our side. Try reloading the page and contact an admin if the problem persists.",
        title = "Oops!",
    } = props;

    return (
        <div className="main-page-wrap page404">
            <div className="center">
                <PageTitle>{title}</PageTitle>
                <Body>{message}</Body>
            </div>
        </div>
    );
};
